<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت   گالری تصاویر</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp; گالری جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.iG_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.iG_Id)" dark v-if="!item.iG_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.iG_Id)" dark v-else> فعال</v-btn>
                            </template>
                            
                            <template v-slot:[`item.iG_ImageUrl`]="{ item }">
                                <v-btn target="_blank" :href="LogoUrl+`${item.iG_ImageUrl}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.iG_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New IG From Dialog-->
            <v-dialog max-width="600px" persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت گالری جدید</span>
                              <span v-else>ویرایش   &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <div style="padding-top:23px;padding-bottom:5px;font-weight:bolder;font-size:17px">تنظیمات اصلی</div>
                                                                      
                                    <v-autocomplete :loading="isLoadingCatItems" v-model="galleryCategory" item-text="gC_Titles" item-value="gC_Id" :items="GalleryCatsItems" no-data-text="دسته بندی موجود نیست" color="#2a2d45" outlined dense label="انتخاب دسته بندی" ></v-autocomplete>
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="GalleryTitle" label="عنوان " ></v-text-field>
                                   
                                    <v-text-field color="#2a2d45" outlined dense v-model="GallerySortField" label="ترتیب نمایش"></v-text-field>
                                    
                                    
                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="GalleryStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                    <f-up :OldFile="Image" @RetunedFileName="Image = $event" Root="GALLERYCHILD" Folder="IMAGEGALLERY" BtnTitle="عکس"></f-up> 
                                   
                                    <v-btn @click="registerGalleryChild" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');

const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
import imgeditor from '../../../components/media/editor.vue';
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    name:"imageGallery",
   components: {
            Loading,
            JsonExcel
        },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        galleryCategory:"",
        searchcategory:"",
        isLoadingCats:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"دسته بندی ",value:"iG_CatTitle",sortable:true,align:"right"},
            {text:"عنوان ",value:"iG_Title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"iG_SortField",sortable:true,align:"right"},
            {text:"عکس",value:"iG_ImageUrl",sortable:true,align:"right"},
            {text:"وضعیت",value:"iG_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        GalleryTitle:"",
        GallerySortField:"",
        GalleryStatus:"",
        originalItems:[],
        ALLOEWDIMGSIZE:{},
        LogoUrl:"",
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "دسته بندی":"iG_CatTitle",
            "عنوان":"iG_Title",
            "ترتیب نمایش":"iG_SortField",
            "وضعیت":"iG_Status",
            "عکس":"iG_ImageUrl",
        },
        BrndDescription:"",
        GalleryCatsItems:[],
        isLoadingCatItems:true,
        Image:"",
        GalleryChildImgUrl:"",
        seo:"",
        SeoData:{}
    }),
    async created()
    {
        let vm = this;
        vm.LogoUrl = ApiUrl.ImageGalleryChild;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadChilds();
        await this.loadGalleryCatCombo();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadChilds();
        this.loadGalleryCatCombo();
        }
    },
    methods:{
        SavedFileName(fname)
        {
           this.Image = fname;
        },
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.seo;
           
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.iG_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteGalleryChild,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.iG_Id = id;
            await axios.post(ApiUrl.ActiveGalleryChild,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.iG_Id = id;
            await axios.post(ApiUrl.DisableGalleryChild,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.galleryCategory = 0;
            vm.GalleryTitle = null;
            vm.GallerySortField = 1;
            vm.GalleryStatus = true;
            vm.Image = "";
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this; 
            vm.CatCreationDialog = true;
            vm.galleryCategory = item.iG_CatId;
            vm.GalleryTitle = item.iG_Title;
            vm.GallerySortField = item.iG_SortField;
            vm.GalleryStatus = item.iG_Status;
            vm.GalleryChildImgUrl =item.iG_ImageUrl;
            vm.Image = item.iG_ImageUrl;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadChilds()
        {
            let vm = this;
            vm.isLoadingCats = true;
            await axios.post(ApiUrl.LoadGalleryChild+'/'+vm.LANG).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadGalleryCatCombo()
        {
            let vm = this;
            vm.isLoadingCatItems = true;

            await axios.post(ApiUrl.LoadGalleryCatCombo+'/1/'+vm.LANG).then((res)=>{
                vm.isLoadingCatItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.GalleryCatsItems = data.data;
                    console.error(vm.GalleryCatsItems);
                    
                }
            }).catch((err)=>{
                vm.isLoadingCatItems = false;
                console.error(err);
            });
        },
        async registerGalleryChild()
        {
            let vm = this;
            let Model = {};
            Model.IG_CatId = vm.galleryCategory;
            Model.IG_Title = vm.GalleryTitle;
            Model.IG_SortField = parseInt(vm.GallerySortField);
            Model.IG_Status = vm.GalleryStatus;
            Model.IG_ImageUrl = vm.Image;
            Model.Lang = vm.LANG;
            let url = ApiUrl.AddGalleryChild;
            if(vm.inEditingItem)
            {
                Model.IG_Id = vm.EditSelectedItem.iG_Id;
                url = ApiUrl.updateGalleryChild;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadChilds();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>